import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "./Primitives";

export const PageShell = ({ eyebrow, title, desc, testid, children }) => {
  const { t } = useLang();
  return (
    <section data-testid={`${testid}-page`} className="mx-auto max-w-[1200px] px-5 sm:px-8 pt-32 pb-24 min-h-screen">
      <Link to="/" data-testid={`${testid}-back`} className="no-print inline-flex items-center gap-2 text-sm text-[color:var(--muted)] hover:text-[color:var(--ink)]">
        <ArrowLeft className="w-4 h-4" /> {t.common.back}
      </Link>
      <Reveal className="mt-8 max-w-3xl no-print">
        <p className="eyebrow mb-5">{eyebrow}</p>
        <h1 data-testid={`${testid}-title`} className="display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">{title}</h1>
        {desc && <p className="mt-5 text-base md:text-lg text-[color:var(--muted)] max-w-xl">{desc}</p>}
      </Reveal>
      <div className="mt-12">{children}</div>
    </section>
  );
};

export const FormError = ({ msg }) => (msg ? <p data-testid="form-error" className="text-sm text-red-700">{msg}</p> : null);
